import * as constants from '../constants/CONSTANT';

const OrderLineItemApi = {
  async fetchByOrder(orderId) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `${constants.API_BASE_URL}/api/orderlineitem/${orderId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },
};

export default OrderLineItemApi;
